import contacts from "./contacts.png";
import feedbackWarning from "./feedback-warning.png";

export default {
  contacts,
  feedbackWarning,
};
